import {isAfter, parseISO} from 'date-fns'
import { Inject, Injectable } from '@angular/core'
import { UserContextStorageService } from './user-context/user-context-storage.service'

@Injectable({
    providedIn: 'root'
})
export class ProjectService {

    constructor(@Inject(UserContextStorageService) private userContextStorageService: any,
                ) {
    }

    isAllowTaxes(): boolean {
        return this.isAttributeAllowed('allowTaxes')
    }

    isContractPayment(): boolean {
        const project = this.userContextStorageService.getProject()

        return project
            && project.projectOption
            && project.projectOption.contractPaymentStart
            && !isAfter(parseISO(project.projectOption.contractPaymentStart), new Date())
    }

    isContractPaymentIncoming(): boolean {
        const project = this.userContextStorageService.getProject()

        return project
            && project.projectOption
            && project.projectOption.contractPaymentIncomingStart
            && !isAfter(parseISO(project.projectOption.contractPaymentIncomingStart), new Date())
    }

    isNonCadastralData(): boolean {
        return this.isAttributeAllowed('nonCadastralData')
    }

    getAllowExportOwned(): boolean {
        return this.isAttributeAllowed('allowExportOwned')
    }

    getAllowIfrsExport(): boolean {
        return this.isAttributeAllowed('allowIfrsExport')
    }

    getAllowInflationIncrease(): boolean {
        return this.isAttributeAllowed('allowInflationIncrease')
    }

    getContractNumberFormat(): string {
        return this.userContextStorageService.getProject()?.projectDefault?.contractNumberFormat
    }

    getDefaultWithdrawPostage(): boolean {
        return this.userContextStorageService.getProject()?.projectDefault?.defaultWithdrawPostage
    }

    getSubcontractNumberFormat(): string {
        return this.userContextStorageService.getProject()?.projectDefault?.subcontractNumberFormat
    }

    isSignatureAllowed(): boolean {
        return this.isAttributeAllowed('allowSignature')
    }

    /**
     * @param attr string
     * return boolean
     */
    private isAttributeAllowed(attr): boolean {
        return this.userContextStorageService.getProject()?.projectOption?.[attr]
    }
}
